<template>

  <el-select v-model="formData" placeholder="Select" @change="updated">
      <el-option-group
        v-for="group in selectData"
        :key="group.label"
        :label="group.label">
        <el-option
          v-for="item in group.options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-option-group>
    </el-select>
</template>

<script>

export default {
  name: 'select-data-type',

  props: {

    label: {
      type: String,
      default: 'Type'
    },

    value: {
      required: true
    },


    prop: {
      type: String,
      default: this.label
    },

    size: {
      type: String,
      default: 'normal'
    },

    disabled: {
      type: Boolean,
      default: false
    },

  },


  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      selectData: [
        {
          label: 'Layout',
          options: [
            {
              value: 'el-row',
              label: 'Row'
            },
            {
              value: 'el-col',
              label: 'Col'
            },
            {
              value: 'h3',
              label: 'Heading'
            },
            {
              value: 'text-area',
              label: 'Static Text'
            }
          ]
        },
        {
        label: 'Inputs',
        options: [
          {
            value: 'text-input',
            label: 'Text'
          },
          {
            value: 'date-input',
            label: 'Date'
          },
          {
            value: 'time-input',
            label: 'Time'
          },
          {
            value: 'number-input',
            label: 'Number'
          },
          {
            value: 'check-box',
            label: 'Check Box'
          },
          {
            value: 'switch-input',
            label: 'Switch'
          },
          {
            value: 'select-input',
            label: 'List'
          },
          {
            value: 'file-upload',
            label: 'File Upload'
          }
        ]
      }
    ],
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectDataType.vue?79622b1c